import {combineReducers} from '@reduxjs/toolkit';
import {user} from 'src/modules/admin/services';
import {changeRequestReview} from 'src/modules/ai/change-request-review/services';
import {attributeInfo} from 'src/modules/attribute/services';
import {attributesInfo} from 'src/modules/attributes/services';
import {attributesFilters} from 'src/modules/attributes/services/filters';
import {changeRequests} from 'src/modules/change-requests/services';
import {changeRequestsFilters} from 'src/modules/change-requests/services/filters';
import {eventInfo} from 'src/modules/event/services';
import {triggerAttachments} from 'src/modules/event-create/header-block/event-trigger-attachment/services';
import {changeRequestInfo} from 'src/modules/event-create/services';
import {eventFamilies} from 'src/modules/event-families/services';
import {eventsInfo} from 'src/modules/events/services';
import {eventsFilters} from 'src/modules/events/services/filters';
import {counts} from 'src/modules/tabs-panel/services';
import {userSettings} from 'src/modules/user-settings/services';
import {usersInfo} from 'src/modules/users-info/services';

export const rootReducer = combineReducers({
    eventInfo,
    attributeInfo,
    changeRequests,
    changeRequestInfo,
    eventsInfo,
    attributesInfo,
    counts,
    user,
    usersInfo,
    userSettings,
    eventsFilters,
    attributesFilters,
    changeRequestsFilters,
    changeRequestReview,
    triggerAttachments,
    eventFamilies,
});
